import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=6c8a83fe&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=6c8a83fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a83fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c8a83fe')) {
      api.createRecord('6c8a83fe', component.options)
    } else {
      api.reload('6c8a83fe', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=6c8a83fe&scoped=true", function () {
      api.rerender('6c8a83fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echartZyz/components/PieChart.vue"
export default component.exports